import { iModalProps } from "@libs/modal-panels/modal-registry-model";

import { GenerateModalWithSuspense } from "@libs/modal-panels/modal-registry-helpers";
import { iWidgetOfflineHours } from "@sdk/chat-widgets/chat-widgets.models";
import React from "react";

const OfflineHoursEditorModal = React.lazy(
  () => import("./offline-hours-editor.modal")
);

const OfflineHoursEditor: iModalProps<
  typeof OfflineHoursEditorModal,
  {
    initialValues: iWidgetOfflineHours;
    onSaved: (config?: iWidgetOfflineHours) => any;
  }
> = {
  name: "offline-hours-editor",
  component: GenerateModalWithSuspense(OfflineHoursEditorModal),
};

export default OfflineHoursEditor;
